import globalAxios from "../GlobalAxios";

const listApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/stron/list', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const addApi = async (data) => {
    try {
      const res = await globalAxios.post('/api/stron/create', data);
  
      return res;
    } catch (error) {
      console.error("error", error);
      // return error.response.data;
    }
}

const deleteApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/stron/delete', data);
    return res.data;
  } catch (error) {
    return error;
  }
}

const detailApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/stron/detail', data);
    return res.data;
  } catch (error) {
    return error;
  }
}

const saveStreamApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/stron/update-info', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const recordStreamApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/stron/record/list', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const statApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/stron/stat/query', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const statStreamApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/stron/stat/query-stream', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const streamListApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/stron/streams', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const recordDeleteApi = async (items) => {
  try {
    const res = await globalAxios.post('/api/stron/record/delete', {items});
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const recordMoveToApi = async (items) => {
  try {
    const res = await globalAxios.post('/api/stron/record/move', {items});
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const recordDownloadApi = async (data) => {
  try {
    const res = await globalAxios.get('/api/stron/record/download', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const controlOptionApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/stron/control-option', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const previewApi = async (data) => {
  try {
    const res = await globalAxios.post(`/api/stron/view-player-code`, data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const savePullInfo = async (data) => {
  try {
    const res = await globalAxios.post(`/api/stron/update-pullInfo`, data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}


export default {
    listApi,
    addApi,
    deleteApi,
    detailApi,
    saveStreamApi,
    recordStreamApi,
    statApi,
    statStreamApi,
    streamListApi,
    recordDeleteApi,
    recordMoveToApi,
    recordDownloadApi,
    controlOptionApi,
    previewApi,
    savePullInfo,
}